import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const ADD_ACCOUNT = 'ADD_ACCOUNT' // 用常量代替事件类型，使得代码更清晰
const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT'
// 注册状态管理全局参数
const store = new Vuex.Store({
  state: {
    token: '',
    token_type: '',
    refresh_token: '',
    expires_in: 0,
    issued: null,
    expires: null,
    expiresType: 'session',
    isLogin: false,
    role: null
  },
  mutations: {
    // 写法与getters相类似
    // 组件想要对于vuex 中的数据进行的处理
    // 组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
    // 内部操作必须在此刻完成(同步)
    [ADD_ACCOUNT] (state, param) { // 第一个参数为 state 用于变更状态 登录
      state.token = param.token
      if (param.rememberClient) {
        state.expiresType = 'local'
      } else {
        state.expiresType = 'session'
      }
      state.token_type = param.token_type
      state.refresh_token = param.refresh_token
      state.expires_in = param.expires_in
      state.issued = param.issued
      state.expires = param.expires
      state.isLogin = true
      state.role = param.role
      window.localStorage.setItem('state', JSON.stringify(state))
    },
    // 退出登录
    [REMOVE_ACCOUNT] (state) {
      window.localStorage.removeItem('state')
      state.token = ''
      state.token_type = ''
      state.refresh_token = ''
      state.expires_in = 0
      state.issued = null
      state.expires = null
      state.expiresType = 'session'
      state.isLogin = false
      state.role = null
    }
  }
})

export default store
// export default new Vuex.Store({
//   state: {},
//   mutations: {},
//   actions: {},
//   modules: {}
// })
